const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Normalizes an image URL:
 * - Returns null for falsy values
 * - Returns absolute URLs as-is
 * - Prepends BACKEND_URL to relative paths
 */
export const getFullImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${BACKEND_URL}${url}`;
};

/**
 * Default placeholder image for restaurants
 */
export const RESTAURANT_PLACEHOLDER = 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=400&fit=crop';
